import React, { PureComponent } from 'react';
import { ISession, IBoard } from 'types';
import Button from 'ui/button';
import { BoardPreview, BoardSelect, BoardForm } from 'components/board';
import { createBoard } from 'data/board';
// Components

interface SessionBoardProps {
  session: ISession;
  availableBoards: IBoard[];
  onChange: (boardKey: string) => void;
}
export default class SessionBoard extends PureComponent<SessionBoardProps> {
  static defaultProps = {
    boards: []
  };

  state = {
    form: false
  };

  handleCreate = () => {
    this.setState({ form: true });
  };

  handleSave = async(board: IBoard) => {
    this.setState({ form: false });
    console.log('BOARD', board);
    const key = await createBoard(board);
    this.props.onChange(key);
  };

  handleCancel = () => this.setState({ form: false });

  render() {
    const { session, availableBoards, onChange } = this.props;
    const { form } = this.state;
    if (form) {
      return (
        <BoardForm
          header={'Create new board'}
          onSave={this.handleSave}
          onCancel={this.handleCancel}
        />
      );
    }
    // if (!session.board) {
    //   return (
    //     <div className="column h-center">
    //       {!!availableBoards.length && <BoardSelect boards={availableBoards} onSelect={onChange} />}
    //       {!availableBoards.length && (
    //       )}
    //     </div>
    //   );
    // }

    return (
      <div>
        <div className="row">
          <div className="flex">
            <BoardSelect
              label="Board used in session"
              selected={session.board}
              boards={availableBoards}
              onSelect={onChange}
            />
          </div>
          <div>
            <Button
              raised="New board"
              onClick={this.handleCreate}
              style={{ marginLeft: 8, height: 46 }}
            />
          </div>
        </div>
        {session.board && (
          <BoardPreview board={availableBoards.find(b => b.key === session.board)} />
        )}
      </div>
    );
  }
}
